// extracted by mini-css-extract-plugin
export var bubble = "_3c-0";
export var container = "_3c-3";
export var contrastBorder = "_3c-4";
export var greyOut = "_3c-2";
export var initialsWrapper = "_3c-1";
export var large = "_3c-9";
export var medium = "_3c-8";
export var mediumSmall = "_3c-7";
export var mediumSmallMedium = "_3c-c";
export var micro = "_3c-5";
export var small = "_3c-6";
export var tiny = "_3c-b";
export var xTiny = "_3c-a";